import React from 'react';

export default class MarkInquiryWarning extends React.Component {

    render() {
        const { inquireNote } = this.props;

        return (
            <div className="error-label error-label-margin-bottom">This application was marked for inquiry
                {inquireNote ? ' | ' + inquireNote : ''}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/MarkInquiryWarning.jsx